var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Workshop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM33 41.34l5.21 2.42L42.27 49h7.1l2.52 9a4 4 0 107.71-2.1S56.81 45.86 56 43a2.28 2.28 0 011.74-3.08l.2-.07c1.87-.62 3.26-2.76 3.26-5.32 0-3-1.84-5.36-4.15-5.49h-18.3L33 32v9.34zm15 2.58l.53 2.08h-4.79l-1.61-2.08H48zM24 32h6v9h-6l-3-3H11v-3h10l3-3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Workshop.97495c1f.svg";
export { SvgE2Workshop as ReactComponent };